import React, { useState, useMemo } from "react";
import { Form, Input, Button, message, Spin } from "antd";
import { getMacPin, setMacPin } from "../adminApi";
import "../css/UpdateMacPin.css";
import { serialNumberRegex } from "../const/regex";

const UpdateMacPin = () => {
  const accessToken = useMemo(() => {
    return localStorage.getItem("access_token");
  }, []);

  const [form] = Form.useForm();
  const [isAvailable, setIsAvailable] = useState(false);
  const [loading, setLoading] = useState(false);

  const showToast = ({ success, message: msg }) => {
    success ? message.success(msg, 3) : message.error(msg, 3);
  };

  const handleCheckMacPin = async (values) => {
    setLoading(true);
    const serial = values.serial.trim();
    try {
      const response = await getMacPin(serial, `Bearer ${accessToken}`);
      if (response.success) {
        setLoading(false);
        form.setFieldsValue({
          mac: response.data.mac,
          pin: response.data.pin,
        });

        setIsAvailable(true);
      }

      showToast(response);
    } catch (error) {
      setLoading(false);
      message.error("Error while checking mac and pin");
    }
  };

  const handleUpdateMacPin = async (values) => {
    setLoading(true);
    const serial = values.serial.trim();
    const mac = values.mac.trim();
    const pin = values.pin.trim();
    try {
      const response = await setMacPin(
        serial,
        mac,
        pin,
        `Bearer ${accessToken}`,
      );
      if (response.success) {
        setLoading(false);
        form.resetFields();
        setIsAvailable(false);
      }

      showToast(response);
    } catch (error) {
      setLoading(false);
      message.error("Error while updating mac and pin");
    }
  };
  const onFinish = isAvailable ? handleUpdateMacPin : handleCheckMacPin;

  if (loading) {
    return (
      <div className="outer-container">
        <div className="inner-container">
          <Spin size="large" className="loader" />
        </div>
      </div>
    );
  }

  return (
    <div className="outer-container">
      <div className="inner-container">
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Serial Number"
            name="serial"
            rules={[
              { required: true, message: "Serial Number is required" },
              {
                pattern: serialNumberRegex,
                message: "Incorrect input or Serial Numbers max limit exceeded",
              },
            ]}
          >
            <Input />
          </Form.Item>
          {isAvailable && (
            <>
              <Form.Item
                label="MAC"
                name="mac"
                rules={[{ required: true, message: "Mac field is required" }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="PIN"
                name="pin"
                rules={[{ required: true, message: "Pin field is required" }]}
              >
                <Input />
              </Form.Item>
            </>
          )}
          <Form.Item>
            {isAvailable ? (
              <Button type="primary" htmlType="submit" block>
                Update Mac and Pin
              </Button>
            ) : (
              <Button type="primary" htmlType="submit" block>
                Check Mac and Pin
              </Button>
            )}
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default UpdateMacPin;
